import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnpin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M16.631 1.832a1.998 1.998 0 0 1 2.828 0l11.314 11.314a1.998 1.998 0 0 1 0 2.828 1.998 1.998 0 0 1-2.828 0l-1.304-1.303-6.046 7.053c.137.46.242.928.315 1.401L9.64 11.722c.42.07.834.167 1.241.288l7.054-6.046-1.304-1.303a1.998 1.998 0 0 1 0-2.829Zm-10.71 9.924c-.935.177-1.857.484-2.738.926l-.177.088a1.975 1.975 0 0 0-1.078 1.467c-.102.641.106 1.282.56 1.737l14.143 14.142a2.01 2.01 0 0 0 1.737.562c.632-.102 1.18-.5 1.467-1.079l.088-.177c.419-.834.716-1.705.897-2.59L5.922 11.757Zm.81 11.29 2.829 2.828-4.243 4.242a1.998 1.998 0 0 1-2.828 0 1.998 1.998 0 0 1 0-2.828l4.243-4.243Z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M2.061 2.642a1.2 1.2 0 0 1 1.698.01l26.434 26.75a1.201 1.201 0 0 1-1.707 1.689L2.051 4.339a1.2 1.2 0 0 1 .01-1.697Z"
	})]
});
export default SvgUnpin;
